import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 4636AAFF-A0E5-494C-8630-31142B4A2F48
 * name microsoft
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft.svg
 * tags
 * - Brand / Logo 
 */
export const MicrosoftIcon = createSvgIcon(<><path d="M2,3H11V12H2V3M11,22H2V13H11V22M21,3V12H12V3H21M21,22H12V13H21V22Z" /></>, 'MicrosoftIcon');
export default MicrosoftIcon